const SELECTOR = '[data-printonary-collector-home]';

function initialiseCollectorHome(root) {
  if (!root || root.dataset.collectorInitialised === 'true') return;
  root.dataset.collectorInitialised = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  const motionEnabled = root.dataset.motion === 'true' && !reducedMotion.matches;
  const revealItems = [...root.querySelectorAll('[data-cg-reveal]')];

  requestAnimationFrame(() => root.classList.add('cg-is-ready'));

  if (!motionEnabled || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('cg-is-visible'));
  } else {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cg-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
    );
    revealItems.forEach((item) => observer.observe(item));
    root.classList.add('cg-motion-ready');
  }

  const hero = root.querySelector('[data-cg-hero]');
  let frame = 0;
  const updateParallax = () => {
    frame = 0;
    if (!hero || !motionEnabled || !desktop.matches) {
      root.style.setProperty('--cg-hero-shift', '0px');
      return;
    }
    const rect = hero.getBoundingClientRect();
    const progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
    root.style.setProperty('--cg-hero-shift', `${(progress - 0.5) * 18}px`);
    root.style.setProperty('--cg-layer-shift', `${(progress - 0.5) * 12}px`);
  };
  const queueParallax = () => {
    if (frame) return;
    frame = requestAnimationFrame(updateParallax);
  };
  if (motionEnabled) {
    window.addEventListener('scroll', queueParallax, { passive: true });
    window.addEventListener('resize', queueParallax, { passive: true });
    updateParallax();
  }

  if (motionEnabled && hoverable.matches) {
    root.querySelectorAll('[data-cg-tilt]').forEach((card) => {
      const visual = card.querySelector('.cg-prop-card__visual');
      if (!visual) return;
      card.addEventListener('pointermove', (event) => {
        const bounds = card.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        visual.style.setProperty('--cg-tilt-y', `${x * 3}deg`);
        visual.style.setProperty('--cg-tilt-x', `${y * -3}deg`);
      });
      card.addEventListener('pointerleave', () => {
        visual.style.removeProperty('--cg-tilt-x');
        visual.style.removeProperty('--cg-tilt-y');
      });
    });
  }
}

function initialiseAll(scope = document) {
  scope.querySelectorAll(SELECTOR).forEach(initialiseCollectorHome);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
} else {
  initialiseAll();
}

document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));

